import React from 'react';
import Modal from '@common/modal';
import Icon from '@common/assets';

import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './marketingPolicyCompleteModal.module.scss';
const cx = classnames.bind(styles);

interface MarketingPolicyCompleteModalProps {
  visible: boolean;
  onClose: () => void;
}

const MarketingPolicyCompleteModal = ({ visible, onClose }: MarketingPolicyCompleteModalProps) => {
  const time = DateFormat.format(new Date(), 'yyyy년 MM월 dd일 HH시 mm분');

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>마케팅 수신 동의 완료!</strong>
        <p className={cx('subTitle')}>
          ‘이벤트 응모’ 버튼을
          <br />
          다시 눌러주세요!
        </p>
        <div className={cx('infoArea')}>
          <div className={cx('infoInner')}>
            <span className={cx('infoTitle')}>전송자</span>
            <span className={cx('infoText')}>잡다</span>
          </div>
          <div className={cx('infoInner')}>
            <span className={cx('infoTitle')}>일시</span>
            <span className={cx('infoText')}>{time}</span>
          </div>
          <div className={cx('infoInner')}>
            <span className={cx('infoTitle')}>처리결과</span>
            <span className={cx('infoText')}>SMS,이메일 알림 수신거부 처리 완료</span>
          </div>
        </div>

        <p className={cx('desc')}>{'추후 마이페이지 > 알림관리에서 변경할 수 있습니다.'}</p>

        <button className={cx('btnConfirm')} onClick={onClose}>
          확인
        </button>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <Icon name="closeLight" width={24} height={24} />
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default MarketingPolicyCompleteModal;
